import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "tb-fsl-content" }
const _hoisted_2 = { class: "tb-fsl-po-heading" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Calculate Full-Service Lease with up to ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "tb-carat" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, " per year and over a ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, " lease period", -1)
const _hoisted_8 = { class: "tb-fsl-po-result text-body-3 mt-3 mb-8" }
const _hoisted_9 = {
  key: 0,
  class: "tb-fsl-msg"
}
const _hoisted_10 = { class: "tb-fsl-po-result-row" }
const _hoisted_11 = { class: "tb-fsl-po-result-col" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("estimated monthly payment")
const _hoisted_15 = { class: "tb-fsl-po-result-col" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Interest Rate", -1)
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 0,
  class: "tb-fsl-po-faq"
}
const _hoisted_21 = { class: "tb-fsl-po-accordion" }
const _hoisted_22 = ["aria-pressed", "aria-controls", "onClick"]
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "tb-arrow-down" }, null, -1)
const _hoisted_25 = ["id", "aria-hidden"]
const _hoisted_26 = ["innerHTML"]

import { ref, computed, onMounted, watch, onBeforeUnmount } from 'vue';
	import { useStore } from 'vuex';
	import { getFslURL } from '@/api';
	import { formatPrice, getCookie } from '@/helpers';
	import { FSLApiData, FSLApiDataDisclaimerItem, FSLApiDataFaqItem, FSLFaqItem, IFSLPayload, IStoreState } from '@/types';
	import VueSelect from 'vue-select';
	import "vue-select/dist/vue-select.css";

	
export default /*#__PURE__*/_defineComponent({
  name: 'DetailHeaderFSLContent',
  setup(__props) {

	const store = useStore<IStoreState>();

	const selectedAccordions = ref<Array<number>>([]);
	const selectedKms = ref<null | number>(null);
	const selectedTerm = ref<null | number>(null);
	const termOptions = ref<Array<string>>([
		'1 year',
		'2 year',
		'3 year',
		'4 year',
	]);
	const kmsOptions = ref<Array<string>>([
		'15,000km',
		'20,000km',
		'30,000km',
		'40,000km',
	]);

	const vehicleHash = computed(() => store.getters['DetailApp/vehicleHash']);
	const fsl = computed((): FSLApiData | null => store.state.DetailApp.fsl);
	const isLoading = computed((): boolean => store.state.DetailApp.isFslLoading); 
	const showFallback = computed(() => {
		return !fsl.value && !isLoading.value;
	});
	const showPrice = computed((): boolean => {
		return !isLoading.value && !!fsl.value?.monthlyCost;
	});
	const showInterest = computed((): boolean => {
		return !isLoading.value && !!fsl.value?.interestRate;
	});
	const monthlyCost = computed((): string => {
		return fsl.value?.monthlyCost ? getFormattedPrice(fsl.value?.monthlyCost) : '';
	});
	const incl = computed(() => {
		if (fsl.value){
			const arr = fsl.value.inclusions.map(o => o.name.replace(/Insurance/g, 'Insurance<sup>[F8]</sup>'));
			const txt = arr.length ? `Includes ${arr.join(', ')}` : '';
			return txt;
		}
		return '';
	});
	const interestRate = computed(() => {
		const txt = `${fsl.value.interestRate}%`;
		return txt;
	});
	const paymentDisclaimerKey = computed((): string => fsl.value?.paymentDisclaimer.key || '');
	const showFaqs = computed(() => faqs.value.filter(o => !!o.content).length);
	const faqs = computed((): Array<FSLFaqItem> => {
		const incFaq: Array<FSLApiDataFaqItem> = fsl.value?.inclusions || [];
		const optExtFaq: Array<FSLApiDataFaqItem> = fsl.value?.optionalExtras || [];
		const ret: Array<FSLFaqItem> = [];
		if (incFaq.length){
			ret.push({
				header: "Inclusions",
				content: getUlLiHtml(incFaq.map(o => o.heading))
			});
		}
		if (optExtFaq.length){
			ret.push({
				header: "Optional extras",
				content: getUlLiHtml(optExtFaq.map(o => o.heading))
			});
		}
		return ret;
	});
	const kms = computed({
		get(): string {
			const arr: Array<string> = kmsOptions.value.filter((o: string) => getNumberFromString(o) == selectedKms.value);
			return arr.length ? arr[0] : kmsOptions.value[0];
		},
		set(v: string) {
			const n = getNumberFromString(v);
			selectedKms.value = n;
		}
	});
	const term = computed({
		get(): string {
			const arr: Array<string> = termOptions.value.filter((o: string) => getNumberFromString(o) == selectedTerm.value);
			return arr.length ? arr[0] : termOptions.value[0];
		},
		set(v: string){
			const n = getNumberFromString(v);
			selectedTerm.value = n;
		}
	});

	const handleAccordionClick = (i: number) => {
		if (isAccordionOpen(i)){
			selectedAccordions.value.splice(selectedAccordions.value.indexOf(i), 1);
		}
		else {
			selectedAccordions.value.push(i);
		}
	};
	const isAccordionOpen = (i: number): boolean => {
		return selectedAccordions.value.includes(i);
	};
	const getFormattedPrice = (p: number): string => {
		return formatPrice(p);
	};
	const getUlLiHtml = (v: Array<string>): string => {
		return '<ul>' + v.map(o => `<li>${o}</li>`).join('') + '</ul>';
	};
	const getNumberFromString = (s: string): number => {
		return parseInt(s.replace(/[^\d]/g, ''));
	};
	const setFslValuesCookie = () => {
		if (!selectedKms.value || !selectedTerm.value) return;
		const dateexp = new Date();
		dateexp.setDate(dateexp.getDate() + 400);//chrome limit apparently.
		const expires = "expires="+ dateexp.toString();
		const cookieData = ";" + expires + ';path=/';
		const vals = `${selectedKms.value},${selectedTerm.value}`;
		document.cookie = "selectedFslValues=" + vals + cookieData;
	};
	const handleFSLInput = async (): Promise<any> => {
		console.log('handleFSLInput');
		await getFSLResult();
		setFslValuesCookie();
		return Promise.resolve();
	};
	const getFSLResult = async (): Promise<any> => {
		store.commit('DetailApp/setFsl', null);
		const zone: string = (window as any).PricingZone || '';
		const url: string = getFslURL();
		const headers: any = {
			headers: {
				"Content-Type": "application/json"
			}
		};
		const data: IFSLPayload = {
			termInYears: selectedTerm.value || 0,
			annualKms: selectedKms.value || 0,
			materialCode: vehicleHash.value,
			pricingZone: zone
		};
		store.commit('DetailApp/setIsFslLoading', true);
		return await fetch(url, {
			method: 'POST',
			headers: headers.headers,
			body: JSON.stringify(data), 
		}).then(response => {
			if (response.status == 200){
				return response.json()
			}
			else {
				throw new Error(`FSL api error ${data.termInYears}, ${data.annualKms}, ${data.materialCode}, ${data.pricingZone}`);
			}
		}).then((json: FSLApiData) => {
			store.commit('DetailApp/setFsl', json);
			store.commit('DetailApp/setIsFslLoading', false);
		}).catch((e: Error) => {
			console.log(e);
			store.commit('DetailApp/setIsFslLoading', false);
		});
	};

	const updateFSLDisclaimers = (v: FSLApiData): void => {
		const di: Array<FSLApiDataDisclaimerItem> = v.disclaimerItems || [];
		const pd: Array<FSLApiDataDisclaimerItem> = [v.paymentDisclaimer];
		const inc: Array<FSLApiDataDisclaimerItem> = v.inclusions.flatMap(o => o.disclaimers);
		const oe: Array<FSLApiDataDisclaimerItem> = v.optionalExtras.flatMap(o => o.disclaimers);
		const all: Array<FSLApiDataDisclaimerItem> = [...di,...pd,...inc,...oe];

		store.dispatch('DetailApp/removeDisclaimer', 'fsl');
		all.forEach((o: FSLApiDataDisclaimerItem) => {
			store.dispatch('DetailApp/addDisclaimer', {
				type: "fsl", 
				for: 'fsl',
				key: o.key, 
				text: o.value
			});
		});
		store.dispatch('DetailApp/updateFooterDisclaimers');
	};
	
	watch(fsl, (v: FSLApiData | null) => {
		if (v){
			updateFSLDisclaimers(v);
		}
	});

	onMounted(() => {
		const fslArr = (getCookie('selectedFslValues') || '').split(',');
		if (fslArr.length == 2 && !fslArr.includes('null')){
			selectedKms.value = parseInt(fslArr[0]);
			selectedTerm.value = parseInt(fslArr[1]);
		}
		else {
			selectedKms.value = getNumberFromString(kmsOptions.value[0]);
			selectedTerm.value = getNumberFromString(termOptions.value[2]);
		}
		getFSLResult();
	});
	onBeforeUnmount(() => {
		store.dispatch('DetailApp/removeDisclaimer', 'fsl');
	});
	watch(vehicleHash, () => {
		getFSLResult();
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _hoisted_3,
      _createVNode(_unref(VueSelect), {
        modelValue: _unref(kms),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(kms) ? (kms).value = $event : null)),
        options: kmsOptions.value,
        clearable: false,
        filterable: false,
        searchable: false,
        disabled: _unref(isLoading),
        "onOption:selected": handleFSLInput
      }, {
        "open-indicator": _withCtx(({ attributes }) => [
          _createElementVNode("span", _normalizeProps(_guardReactiveProps(attributes)), _hoisted_5, 16)
        ]),
        _: 1
      }, 8, ["modelValue", "options", "disabled"]),
      _hoisted_6,
      _createElementVNode("span", null, _toDisplayString(_unref(term)), 1),
      _hoisted_7
    ]),
    _createElementVNode("p", _hoisted_8, [
      (_unref(showFallback))
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Full-Service Lease pricing is currently unavailable."))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (_unref(showPrice))
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_12, _toDisplayString(_unref(monthlyCost)), 1))
                  : (_unref(isLoading))
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_13, " "))
                    : _createCommentVNode("", true),
                _createElementVNode("span", null, [
                  _hoisted_14,
                  _createElementVNode("sup", null, _toDisplayString(_unref(paymentDisclaimerKey)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                (_unref(showInterest))
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_16, _toDisplayString(_unref(interestRate)), 1))
                  : (_unref(isLoading))
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_17, " "))
                    : _createCommentVNode("", true),
                _hoisted_18
              ])
            ]),
            _createElementVNode("small", { innerHTML: _unref(incl) }, null, 8, _hoisted_19)
          ], 64))
    ]),
    (_unref(showFaqs))
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("dl", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(faqs), (f, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "tb-fsl-po-accordion-item"
              }, [
                _createElementVNode("dt", null, [
                  _createElementVNode("button", {
                    type: "button",
                    "aria-pressed": isAccordionOpen(i),
                    "aria-controls": `tb-fsl-po-accordion-item-dd-${i}`,
                    onClick: _withModifiers(($event: any) => (handleAccordionClick(i)), ["prevent"])
                  }, [
                    _createElementVNode("div", {
                      innerHTML: f.header
                    }, null, 8, _hoisted_23),
                    _hoisted_24
                  ], 8, _hoisted_22)
                ]),
                _createElementVNode("dd", {
                  id: `tb-fsl-po-accordion-item-dd-${i}`,
                  "aria-hidden": !isAccordionOpen(i)
                }, [
                  _createElementVNode("div", {
                    innerHTML: f.content
                  }, null, 8, _hoisted_26)
                ], 8, _hoisted_25)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})